import { render } from "./PriceTable.vue?vue&type=template&id=1de9015d&scoped=true"
import script from "./PriceTable.vue?vue&type=script&lang=js"
export * from "./PriceTable.vue?vue&type=script&lang=js"

import "./PriceTable.vue?vue&type=style&index=0&id=1de9015d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de9015d"]])

export default __exports__